import { Component } from "@angular/core";

@Component({
    selector: "admin-unauthorized",
    imports: [],
    templateUrl: "./admin-unauthorized.component.html"
})
export class AdminUnauthorizedComponent {
    
}